import React, { useEffect } from "react";

import { connect } from "react-redux";
import { RootState } from "src/ipm-shared/store/model/reducers";
import { ACCOUNT_TYPE } from "src/ipm-shared/store/model/AccountProfile/const";
import { history } from "src/ipm-shared/store";
import { FetchModalID } from "src/bepaid/store/model/Fetch/actions";
import ROUTES from "../routes";

import * as selectors from "src/bepaid/store/model/Fetch/selectors";
import * as actions from "src/bepaid/store/model/Fetch/actions";
import * as queryString from "query-string";

const mapStateToProps = (state: RootState) => ({
  isAustraliaAccount: selectors.isAustraliaAccount(state),
  acquirerId: selectors.getAcquirerId(state),
  accountProfile: selectors.getCurrentAccountProfile(state)
});

const mapDispatchToProps = {
  toggleModal: actions.toggleModal,
  closeModal: actions.closeModal
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

const withPopup = (
  WrapperComponent: any,
  {
    modalId,
    extraInfo,
    pushExtraInfoFromProps,
    refModalIds = []
  }: {
    modalId: number;
    extraInfo?: any;
    pushExtraInfoFromProps?: any;
    refModalIds?: number[];
  }
) => {
  const HOC = (props: any) => {
    useEffect(() => {
      const qs = queryString.parse(window.location.search);
      const modalIdOnQuery = parseInt(qs.m as string, 10);
      const { userSettingRequired, type } = props.accountProfile || {};
      const isRequireAdditionalData =
        userSettingRequired?.additionalDataModal &&
        type === ACCOUNT_TYPE.PERSONAL;

      if (
        modalId === FetchModalID.ADDITIONAL_DATA_MODAL &&
        !isRequireAdditionalData
      ) {
        return history.push(ROUTES.ROOT);
      }

      if (modalIdOnQuery && refModalIds.includes(modalIdOnQuery)) {
        return () => {
          props.closeModal(modalIdOnQuery);
        };
      }

      if (refModalIds && refModalIds.includes(modalIdOnQuery)) {
        // no need to open modalId
      } else {
        let extraInfoData = extraInfo;
        if (pushExtraInfoFromProps) {
          extraInfoData = {
            ...extraInfoData,
            ...pushExtraInfoFromProps(props)
          };
        }

        props.toggleModal(modalId, extraInfoData);
      }

      return () => {
        props.closeModal(modalId);

        if (modalIdOnQuery) {
          props.closeModal(modalIdOnQuery);
        }
      };
    }, [window.location.pathname]);

    return <WrapperComponent {...props} isBgOfPopup={true} />;
  };

  return connect(mapStateToProps, mapDispatchToProps)(HOC);
};

export default withPopup;
